import { render, staticRenderFns } from "./FormRF06.vue?vue&type=template&id=67227144&scoped=true&"
import script from "./FormRF06.vue?vue&type=script&lang=js&"
export * from "./FormRF06.vue?vue&type=script&lang=js&"
import style0 from "./FormRF06.vue?vue&type=style&index=0&id=67227144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67227144",
  null
  
)

export default component.exports